<template>
    <div class="card" @click="$emit('click')">
        <img class="logo" :src="url" alt="">
        <div class="desc">{{ desc }}</div>
    </div>
</template>

<script>
export default {
    props: {
        url: '',
        desc: ''
    }
}
</script>

<style scoped lang="less">
.card{
  width: 100%;
  box-sizing: border-box;
  padding: 10px;
  margin-top: 30px;
  background: #332A25;
  border-radius: 10px;
  display: flex;
  justify-content: space-between;
  .logo{
    width: 40%;
    height: 90px;
    border-radius: 10px;
  }
  .desc{
    padding-left: 12px;
    font-size: 16px;
    color: #b8a294;
    line-height: 26px;
    text-align: left;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
  }
}
</style>
